import { BusinessContext } from '@types';
import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetSonarObjectBusinessContextRequest = {
	sonarObjectId: number;
};

export const getSonarObjectBusinessContext = createGetEndpoint<GetSonarObjectBusinessContextRequest, BusinessContext>(
	({ sonarObjectId }) => `/api/v3/core/sonar-objects/${sonarObjectId}/context`
);
